"use client";
import { QuoteRequestFIT } from "@/app/sur-mesure/individuel/_components/QuoteRequestFIT";
import { Budget } from "@/components/search/search/filters/Budget";
import { Destinations } from "@/components/search/search/filters/Destinations";
import { Duration } from "@/components/search/search/filters/Duration";
import { Themes } from "@/components/search/search/filters/Themes";
import { SecondaryButton } from "ui/components";

export const FiltersFIT = () => {
  return (
    <div className="flex flex-wrap items-center justify-between gap-4">
      <div className="flex flex-wrap gap-2">
        <Destinations isDesktop fit />
        <Themes isDesktop fit />
        <Duration isDesktop fit />
        <Budget isDesktop fit />
      </div>
      <QuoteRequestFIT heading="Demander un devis" openOnParam="f">
        <SecondaryButton as="span">Demander un devis</SecondaryButton>
      </QuoteRequestFIT>
    </div>
  );
};
